import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Layout from "../Utils/Layout";
import { useNavigate } from "react-router-dom";

const Cloud = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="py-4 fs-3 ps-3 " data-aos="fade-left">
        <button
          onClick={() => navigate(-1)}
          className="btn btn-info fw-bold ms-5"
        >
          Back
        </button>
      </div>
      <Helmet>
        <title>Cloud Computing | Shoyeb</title>
        <meta
          name="description"
          content="Explore our cloud computing services to leverage the power of the cloud for your business. We offer solutions for cloud migration, deployment, management, and optimization."
        />
        <meta
          name="keywords"
          content="cloud computing services, cloud migration, cloud deployment, cloud management, cloud optimization"
        />
      </Helmet>
      <Container>
        <Row className="mt-5" data-aos="fade-right">
          <Col>
            <h1 className="text-center">Cloud Computing Services</h1>
            <p className="lead text-center">
              Harness the potential of cloud computing to scale your business
              operations and drive innovation.
            </p>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col md={6} data-aos="fade-down">
            <h3>Our Services</h3>
            <ul>
              <li>Cloud migration</li>
              <li>Cloud deployment</li>
              <li>Cloud management</li>
              <li>Cloud optimization</li>
              <li>Infrastructure as a Service (IaaS)</li>
              <li>Platform as a Service (PaaS)</li>
            </ul>
          </Col>
          <Col md={6} data-aos="fade-up">
            <h3>Why Choose Us?</h3>
            <p>
              Our cloud computing experts have extensive experience in helping
              businesses leverage cloud technologies to streamline operations,
              reduce costs, and improve scalability.
            </p>
            <p>
              Whether you need assistance with cloud migration, deployment,
              management, or optimization, we provide tailored solutions to meet
              your specific requirements and business objectives.
            </p>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col data-aos="fade-right">
            <h3>Benefits of Cloud Computing</h3>
            <ul>
              <li>Scalability and flexibility</li>
              <li>Cost-effectiveness</li>
              <li>Improved reliability and security</li>
              <li>Enhanced collaboration and productivity</li>
              <li>Access to advanced technologies</li>
            </ul>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col data-aos="fade-down">
            <h3>Contact Us</h3>
            <p>Ready to take advantage of cloud computing for your business?</p>
            <a href="mailto:shoyebmd424@mail.com" className="btn btn-info">
              Contact Us
            </a>{" "}
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default Cloud;
